"use client";

import { useLocale } from "next-intl";
import { cn } from "~/lib/utils";
import type { PokemonType } from "~/types/pokemon";
import { getTypeIconAlt } from "~/lib/pokemon";
import Image from "next/image";

interface TypeIconProps {
  type: PokemonType;
  className?: string; // Add className prop for flexibility
  locale?: string;
}

const TypeIcon = ({ type, className, locale }: TypeIconProps) => {
  const intlLocale = useLocale();
  const activeLocale = locale ?? intlLocale;

  const typeColors: Record<PokemonType, string> = {
    fire: "bg-fire",
    water: "bg-water",
    electric: "bg-electric",
    grass: "bg-grass",
    ice: "bg-ice",
    fighting: "bg-fighting",
    poison: "bg-poison",
    ground: "bg-ground",
    flying: "bg-flying",
    psychic: "bg-psychic",
    bug: "bg-bug",
    rock: "bg-rock",
    ghost: "bg-ghost",
    dragon: "bg-dragon",
    dark: "bg-dark",
    steel: "bg-steel",
    fairy: "bg-fairy",
    normal: "bg-normal",
  };

  return (
    <span
      className={cn(
        "flex min-h-[2em] min-w-[2em] items-center justify-center rounded-2xl text-base font-bold",
        typeColors[type],
        className,
      )}
    >
      <Image
        className="h-[1em] w-[1em]"
        src={`/pokemon-type-icons/pokemon_type_${type}.svg`}
        alt={getTypeIconAlt(type, activeLocale)}
        width={32}
        height={32}
      />
    </span>
  );
};

export default TypeIcon;
